import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { mapTree } from '@blade-sxp/pass/utils/map-tree';
import _ from 'lodash';
import { StaffModule } from '@blade-sxp/pass/store/staff';
let default_1 = class default_1 extends Vue {
    currVal;
    currIndex = '';
    defaultExpandKey = [];
    value = [];
    isShow = false;
    currNode;
    input = '';
    inputDebounce = _.debounce(this.handleInput, 350);
    treeData = [];
    otherNode = []; // 不属于当前搜索人员树，但已选中的数据
    async mounted() {
        this.value = this.currVal;
        await this.handleInput();
        this.isShow = false;
    }
    // checkNodes(treeData: Array<ITree>, id: string) :boolean {
    //   for (let item of treeData) {
    //     if (item.parent) {
    //       this.checkNodes(item.children, id);
    //     } else if (item.id === id) { return false; }
    //   }
    //   return true;
    // }
    async handleInput() {
        this.value = this.currVal;
        try {
            const res = await StaffModule.getTags(this.input);
            const depts = res.data ? mapTree([res.data]) : [];
            this.treeData = depts;
            console.log('tree data:', this.treeData);
            // console.log('flatted tree:', [res.data]);
            // this.treeData = depts.map(item => {
            //   if (item.parent) {
            //     item.id = `p${item.id}`;
            //   }
            //   return item;
            // });
            // debugger;
            this.onShow();
        }
        catch (e) {
            console.log('e:', e);
        }
    }
    handleClick(e, selected) {
        // console.log('e:', e);
        // console.log('selected', selected);
        let checked = this.value;
        if (selected) {
            const selectedNodes = this.$refs.tree.getCheckedNodes();
            checked.push(...selectedNodes);
            const removeDup = _.uniqBy(checked, 'key');
            checked = removeDup;
            // checked = selectedNodes;
        }
        else {
            checked = checked.filter(item => item.id !== e.id);
        }
        const filterParent = checked?.length > 0 ? checked.filter((item) => item.type === 1) : [];
        console.log('res:', checked);
        this.value = checked;
        // this.value = checked.filter(item => item.type === 1);
        this.$emit('on-click', this.value);
    }
    async onShow() {
        this.isShow = true;
        if (this.value?.length > 0) {
            const mappedValue = this.value.map((item) => { return { key: `${item.id}-${item.type}`, ...item }; });
            const res = mappedValue.map((item) => item.key);
            console.log('res:', res);
            this.defaultExpandKey = res;
            this.$refs.tree.setCheckedKeys(res);
        }
    }
    onTagChange(newVal, oldVal) {
        this.value = newVal;
        // console.log('value:', this.value);
        if (oldVal?.length > 0 && !newVal?.length) {
            this.$refs.tree.setCheckedKeys([]);
        }
    }
    handleHide() {
        this.closeInit();
    }
    handleClose() {
        this.isShow = false;
        this.closeInit();
        this.$emit('updateName', this.currNode);
    }
    closeInit() {
        this.currIndex = '';
        this.value = [];
    }
};
__decorate([
    Prop({ type: Array })
], default_1.prototype, "currVal", void 0);
__decorate([
    Watch('currVal', { immediate: true })
], default_1.prototype, "onTagChange", null);
default_1 = __decorate([
    Component({
        name: 'TreePopover',
        i18n: {
            messages: {
                'en-us': {
                    searchHolder: 'Please input name/organization'
                },
                zh: {
                    searchHolder: '请输入姓名/组织'
                },
            },
        },
    })
], default_1);
export default default_1;
